module.exports = __webpack_public_path__ + "assets/img/icon-all.4e2ea550.png";